import { useMemo } from 'react'

import useAuth from 'hooks/use-auth'

export default function useFreeEditionMetrics() {
  let { hasCompanyPrivilege, companyPrefs, RBAC } = useAuth()

  const canUpdateCompanyAttackVisualizations = hasCompanyPrivilege(
    RBAC.privileges.company.MANAGE_COMPANY_PREFS
  )

  const val = useMemo(
    () => ({
      isOptIn: companyPrefs?.monitoring?.opt_in?.value === true,
      canUpdateCompanyAttackVisualizations
    }),
    [
      canUpdateCompanyAttackVisualizations,
      companyPrefs?.monitoring?.opt_in?.value
    ]
  )

  return val
}
